export const roleOptions = [
    { value:'User', label:'User' },
    { value:'Admin', label:'Admin' },
    { value:'Manager', label:'Manager' },
    { value:'Precision', label:'Precision' },
];

export const roleOptionsAdmin = [
    { value:'User', label:'User' },
    { value:'Manager', label:'Manager' },
    { value:'Admin', label:'Admin' },
];